module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Tack för ditt intresse {email}! Vi hör av oss inom kort!":"Thank you for your interest {email}! We will be in touch shortly!"},"sv":{"Tack för ditt intresse {email}! Vi hör av oss inom kort!":"Tack för ditt intresse {email}! Vi hör av oss inom kort!"}}')
  delete Component.options._Ctor
}
